import { ReactComponent as TidaLogo } from '../tida.svg';
import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', minHeight: '100vh', backgroundColor: '#000',
            color: '#fff', fontFamily: 'Raleway, sans-serif', gap: '1.5rem',
            textAlign: 'center', padding: '2rem'
        }}>
            <TidaLogo style={{ width: 72, height: 72, fill: '#FFD200', opacity: 0.9 }} />
            <h1 style={{ fontSize: '5rem', fontWeight: 800, color: '#FFD200', margin: 0, lineHeight: 1 }}>404</h1>
            <p style={{ fontSize: '1.1rem', opacity: 0.7, maxWidth: 360 }}>
                This page doesn't exist — but the rest of the site does.
            </p>
            <Link to="/" style={{
                color: '#FFD200', fontSize: '0.95rem', textDecoration: 'none',
                border: '1px solid #FFD200', padding: '8px 20px', borderRadius: 8
            }}>
                ← Back home
            </Link>
        </div>
    );
}
